import Vue from 'vue'
import App from './app'
import router from './router'


import 'lib-flexible'
import '../static/css/reset.css'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import commonJS from './common/js/commonJS'

function isAndroid(){
	var u = navigator.userAgent
	var isAndroid = u.indexOf('Android')>-1||u.indexOf('Linux')>-1
	if(isAndroid){
		return true
	}else{
		return false
	}
}
function iosUrlRefresh(to){
	let iosRandom = 'iosRandom='+new Date().getTime()
	let url = location.protocol + '//' + location.host + to.fullPath
	if(url.indexOf('?')>0){
		url = url + '&' + iosRandom
	}else{
		url = url + '?' + iosRandom
	}
	window.location.replace(url)
}

router.beforeEach((to, from, next) => {
  document.title = to.meta.title		//修改各个页面的title
  if (!/micromessenger/i.test(navigator.userAgent)) {
    alert('此网站只能在微信浏览器打开！')
    return
  }
  //不要对 WxAuth 路由进行拦截，不进入 WxAuth 路由就拿不到微信返回的授权 code
  if(to.name == 'errorpage') {
    next()
    return
  }
  if(to.name == 'wxauth' || to.name == 'auth') {
    console.log('[路由守卫] 放行授权页面:', to.name)
    next()
    return
  }
  var NextData= {
    name:to.name,
    path: to.path,
    params: to.params
  }
  if(from.params.companyId){
    //路由切换时，如果没有就添加，有就跳过执行，添加固定参数
    if (!to.params.companyId) {
      //准备一个跳转的query对象
      let params = to.params
      params.companyId = from.params.companyId
      NextData = {
        name:to.name,
        path: to.path,
        params: params
      }
    }
  }else{
    if(!to.params.companyId){
      console.log('[路由守卫] 缺少companyId，跳转错误页')
      next({
        name:'errorpage',
        path: '/errorpage',
      })
      return
    }
  }

  console.log('[路由守卫] 检查cookie:', {
    to: to.name,
    from: from.name,
    wxUserInfo: document.cookie.indexOf('wxUserInfo='),
    userInfo: document.cookie.indexOf('userInfo='),
    allCookies: document.cookie
  })

  if(document.cookie.indexOf('wxUserInfo=') === -1){
    console.log('[路由守卫] wxUserInfo不存在 → 跳转wxauth')
    next({
      name:'wxauth',
      path: '/wxauth',
      params: NextData.params
    })
    return
  }
  if(document.cookie.indexOf('userInfo=') === -1){
    if(to.name!='wxauth'){
      console.log('[路由守卫] userInfo不存在 → 跳转wxauth')
      next({
        name:'wxauth',
        path: '/wxauth',
        params: NextData.params
      })
      return
    }
  }
  console.log('[路由守卫] cookie检查通过 → 放行到', to.name)
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
})



// WEBPACK FOOTER //
// ./src/main.js